import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function ResumeExamples() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Resume Examples by Job (2026 Guide)"
        description="Explore resume examples for different jobs. Learn how to write a professional resume for your role and stand out to employers."
        canonical="https://employpilot.com/resume-examples"
      />

      <h1>Resume Examples for Different Jobs (2026 Guide)</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Looking at resume examples is one of the fastest ways to improve your own.
        Seeing how successful resumes are structured can help you stand out.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The best resumes are tailored to specific roles and highlight relevant experience.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Build My Resume Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Resume Examples by Job Type</h2>

      <h3>Entry-Level Resume Example</h3>
      <p>
        Focus on education, skills, and projects. Highlight your potential and willingness to learn.
      </p>

      <h3>Customer Service Resume Example</h3>
      <p>
        Emphasize communication skills, problem-solving, and customer satisfaction achievements.
      </p>

      <h3>Marketing Resume Example</h3>
      <p>
        Showcase campaigns, analytics, and measurable results such as growth or engagement.
      </p>

      <h3>Tech Resume Example</h3>
      <p>
        Highlight technical skills, projects, and tools you’ve used. Include links to portfolios if possible.
      </p>

      <h3>Management Resume Example</h3>
      <p>
        Focus on leadership, team results, and business impact.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>What Makes a Strong Resume?</h2>

      <ul>
        <li>✔ Clear structure and formatting</li>
        <li>✔ Relevant experience</li>
        <li>✔ Measurable achievements</li>
        <li>✔ Tailored to the job</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Use Resume Examples</h2>

      <ol>
        <li>Use them as inspiration—not copies</li>
        <li>Adapt them to your own experience</li>
        <li>Focus on results and impact</li>
        <li>Keep your resume unique</li>
      </ol>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need the right format?{" "}
        <Link to="/best-resume-format">
          Learn the best resume format
        </Link>
      </p>

      <p>
        Writing your summary?{" "}
        <Link to="/resume-summary-examples">
          See resume summary examples
        </Link>
      </p>

      <p>
        Need help building your resume?{" "}
        <Link to="/ai-resume-builder">
          Use the AI Resume Builder
        </Link>
      </p>

      {/* COMMUNITY CTA */}
      <p style={{ marginTop: "30px" }}>
        Want feedback on your resume?{" "}
        <strong>Join the EmployPilot Community</strong> to get advice from others.
      </p>

      <p style={{ fontSize: "14px", color: "#777" }}>
        (Free account required)
      </p>

      <Link to="/community">
        Explore the Community
      </Link>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Create a Resume That Gets Results</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Start Now
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What is the best resume format for different jobs?</h3>
      <p>
        The reverse chronological format works best for most roles, but tailoring your content is key.
      </p>

      <h3>Should I copy resume examples?</h3>
      <p>
        No. Use examples as inspiration, but make your resume unique to your experience.
      </p>

      <h3>Can AI create resume examples for me?</h3>
      <p>
        Yes. EmployPilot can generate tailored resumes based on your job and experience.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default ResumeExamples;